import { render, staticRenderFns } from "./NextChallengeCard.vue?vue&type=template&id=bb7678d4&"
import script from "./NextChallengeCard.vue?vue&type=script&lang=ts&"
export * from "./NextChallengeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports